  <ape-admin-impersonate-template
    [showSkeletonLoader]="showSkeletonLoader"
    [users]="users"
    [searchValue]="searchValue"
    [loading]="loading"
    [totalItems]="totalItems"
    [page]="page"
    [pageSize]="pageSize"
    (searchChange)="onSearchChange($event)"
    (search)="onSearch($event)"
    (impersonateEmployee)="onImpersonateEmployee($event)"
    (impersonateManager)="onImpersonateManager($event)"
  />